import React from "react";
import { Link } from "react-router-dom";
import { useMarcelMode } from "@/context/MarcelMode.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function MorePage() {
  const { ui } = useOrignalUi();
  const { actingAsAdmin } = useMarcelMode();
  const links = [
    { to: "/chasse-2026", label: ui.nav.hunt },
    { to: "/menu", label: ui.nav.menu },
    { to: "/a-savoir", label: ui.nav.know },
    { to: "/vehicules", label: ui.nav.vehicles },
    { to: "/depenses", label: ui.nav.expenses },
    { to: "/taches", label: ui.nav.tasks },
    { to: "/materiel", label: ui.nav.gear },
    { to: "/preparation", label: ui.nav.prep },
    { to: "/mes-affaires", label: ui.nav.myStuff },
    { to: "/hebergement", label: ui.nav.lodging },
    { to: "/sejours", label: ui.nav.trips },
    { to: "/observations", label: ui.nav.observations },
    { to: "/documents", label: ui.nav.documents },
    { to: "/historique", label: ui.nav.history },
    { to: "/recherche", label: ui.nav.search },
    { to: "/notifications", label: ui.nav.notifications },
    { to: "/parametres", label: ui.nav.settings },
  ];
  if (actingAsAdmin) links.push({ to: "/admin", label: ui.nav.admin });
  return (
    <main className="og-page" data-testid="page-more">
      <h1>{ui.more.title}</h1>
      <p className="og-lead">{ui.more.subtitle}</p>
      <div className="og-more-grid">
        {links.map((link) => (
          <Link key={link.to} to={link.to} className="og-card og-card--link" data-testid={`more-${link.to.slice(1)}`}>
            {link.label}
          </Link>
        ))}
      </div>
    </main>
  );
}
